import { useContext } from 'react'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { ProductContext } from 'src/components/restructure/product/contexts'
import { dedupeProgressiveTiers } from 'src/components/restructure/product/utils/progressiveDiscountPricing'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { getProductQueryObject } from 'src/utils/amplitude/useProductObject'

import { ProgressiveDiscountTiers } from './ProgressiveDiscountTiers'

export function ProgressiveDiscount() {
  const { pageData } = useGlobalContext()
  const { currentSku, quantity, setQuantity, progressiveDiscount } =
    useContext(ProductContext)

  const standardObject = getStandardObject(pageData)
  const productObject = getProductQueryObject(currentSku)

  const skuProgressDiscount = progressiveDiscount?.items.find(
    (pd) => String(pd.itemId) === String(currentSku.itemId)
  )

  if (!skuProgressDiscount) {
    return null
  }

  const tiers = dedupeProgressiveTiers(skuProgressDiscount.tiers)

  const onSelectTier = (q: number) => {
    setQuantity(q)
    const selected = tiers.find((t) => t.quantity === q)

    dispatchAmplitudeEvent({
      eventName: 'Progressive Discount',
      eventData: {
        ...standardObject,
        'product details': productObject
          ? [{ ...productObject, quantity: q }]
          : [],
        'progressive discount': `${selected?.discountPercentage ?? 0}% off`,
      },
    })
  }

  return (
    <section data-component="progressive-discount" className="mt-6">
      <p className="hidden sm:block text-xs font-semibold uppercase tracking-wider text-restructure-secondary mb-3">
        Desconto progressivo
      </p>
      <ProgressiveDiscountTiers
        tiers={tiers}
        quantity={quantity}
        onSelectTier={onSelectTier}
      />
    </section>
  )
}
